import { Outlet } from "react-router-dom";
import NexusHeader from "@/components/NexusHeader";
import NexusFooter from "@/components/NexusFooter";
import SiteWidget from "@/components/SiteWidget";
import CookieConsent from "@/components/CookieConsent";
import { NexusHomeContentProvider } from "@/contexts/NexusHomeContentContext";

/**
 * Layout wrapper for all Elido-owned public pages (homepage, /hemsidor,
 * SEO landing pages, blog, legal). Provides the shared header, footer, and
 * the Elido Nexus Core widget so individual pages only need to render their
 * own content.
 *
 * NOT used on:
 *  - /d/:slug, /demo  → those render the customer's own generated site, so
 *    they must NOT show Elido branding or the Elido widget.
 *  - /admin/*, /login, /auth/*, /start  → standalone app shells.
 */
export default function NexusLayout() {
  return (
    <NexusHomeContentProvider>
      <div className="min-h-screen bg-[#0a1418] font-['Inter']" data-testid="nexus-layout">
        <NexusHeader />
        <Outlet />
        <NexusFooter />
        <SiteWidget />
        <CookieConsent />
      </div>
    </NexusHomeContentProvider>
  );
}
